/**
 * Created by Mikhail Menshenin on 03.07.2024
 */

CoinSlotMachine.REELS_AMOUNT = 3;
CoinSlotMachine.REEL_SPIN_DELAY = 300;

CoinSlotMachine.COIN_SYMBOL = {
    type: "coin",
    exclude: ["stack"],
    icon: bundles.slotmachine.frames.coin_png,
    sliding_icon: bundles.slotmachine.frames.coin_sliding_png
};

CoinSlotMachine.STACK_SYMBOL = {
    type: "stack",
    exclude: ["coin"],
    icon: bundles.slotmachine.frames.stack_png,
    sliding_icon: bundles.slotmachine.frames.stack_sliding_png
};

CoinSlotMachine.ENERGY_SYMBOL = {
    type: "energy",
    icon: bundles.slotmachine.frames.energy_png,
    sliding_icon: bundles.slotmachine.frames.energy_sliding_png
};

CoinSlotMachine.ATTACK_SYMBOL = {
    type: "attack",
    icon: bundles.slotmachine.frames.attack_png,
    sliding_icon: bundles.slotmachine.frames.attack_sliding_png
};

CoinSlotMachine.SHIELD_SYMBOL = {
    type: "shield",
    icon: bundles.slotmachine.frames.shield_png,
    icon_large: bundles.slotmachine.frames.shield_large_png,
    sliding_icon: bundles.slotmachine.frames.shield_sliding_png
};

CoinSlotMachine.RAID_SYMBOL = {
    type: "raid",
    icon: bundles.slotmachine.frames.raid_png,
    sliding_icon: bundles.slotmachine.frames.raid_sliding_png
};

CoinSlotMachine.SYMBOLS = {};
CoinSlotMachine.SYMBOLS[CoinSlotMachine.COIN_SYMBOL.type] = CoinSlotMachine.COIN_SYMBOL;
CoinSlotMachine.SYMBOLS[CoinSlotMachine.STACK_SYMBOL.type] = CoinSlotMachine.STACK_SYMBOL;
CoinSlotMachine.SYMBOLS[CoinSlotMachine.ENERGY_SYMBOL.type] = CoinSlotMachine.ENERGY_SYMBOL;
CoinSlotMachine.SYMBOLS[CoinSlotMachine.ATTACK_SYMBOL.type] = CoinSlotMachine.ATTACK_SYMBOL;
CoinSlotMachine.SYMBOLS[CoinSlotMachine.SHIELD_SYMBOL.type] = CoinSlotMachine.SHIELD_SYMBOL;
CoinSlotMachine.SYMBOLS[CoinSlotMachine.RAID_SYMBOL.type] = CoinSlotMachine.RAID_SYMBOL;

CoinSlotMachineReel.SYMBOLS = [
    CoinSlotMachine.ATTACK_SYMBOL,
    CoinSlotMachine.STACK_SYMBOL,
    CoinSlotMachine.ENERGY_SYMBOL,
    CoinSlotMachine.COIN_SYMBOL,
    CoinSlotMachine.RAID_SYMBOL,
    CoinSlotMachine.STACK_SYMBOL,
    CoinSlotMachine.SHIELD_SYMBOL,
    CoinSlotMachine.COIN_SYMBOL,
    CoinSlotMachine.ATTACK_SYMBOL,
    CoinSlotMachine.STACK_SYMBOL,
    CoinSlotMachine.RAID_SYMBOL,
    CoinSlotMachine.SHIELD_SYMBOL,
    CoinSlotMachine.COIN_SYMBOL
];

CoinSlotMachine.getRewardByVillageCost = function (coeff) {
    return function () {
        const village = cleverapps.meta.getSelectedLocation().village;
        const cost = village.cost;
        return {
            hard: Math.round(coeff * cost / 100) * 100
        };
    };
};

CoinSlotMachine.PAYLINES = [
    {
        payline: ["coin", "coin", "coin"],
        animation: "3coins",
        reward: CoinSlotMachine.getRewardByVillageCost(0.00513),
        effect: "slotmachine.coin.win"
    },
    {
        payline: ["coin", "coin"],
        animation: "2coins",
        reward: CoinSlotMachine.getRewardByVillageCost(0.00051),
        effect: "slotmachine.coin"
    },
    {
        payline: ["coin"],
        animation: "1coin",
        reward: CoinSlotMachine.getRewardByVillageCost(0.00026),
        effect: "slotmachine.coin"
    },
    {
        payline: ["stack", "stack", "stack"],
        animation: "3bags",
        reward: CoinSlotMachine.getRewardByVillageCost(0.02051),
        effect: "slotmachine.stack"
    },
    {
        payline: ["stack", "stack"],
        animation: "2bags",
        reward: CoinSlotMachine.getRewardByVillageCost(0.00256),
        effect: "slotmachine.coin"
    },
    {
        payline: ["stack"],
        animation: "1bag",
        reward: CoinSlotMachine.getRewardByVillageCost(0.00128),
        effect: "slotmachine.coin"
    },
    {
        payline: ["shield", "shield", "shield"],
        spine: bundles.slotmachine.jsons.reward_shield_json,
        icon_animation: "shield_reward",
        reward: {
            shields: 1
        },
        message: "SlotMachine.Message.Shield",
        effect: "slotmachine.shield"
    },
    {
        payline: ["energy", "energy", "energy"],
        spine: bundles.slotmachine.jsons.reward_energy_json,
        icon_animation: "energy_reward",
        reward: {
            energy: 10
        },
        effect: "slotmachine.energy"
    },
    {
        payline: ["attack", "attack", "attack"],
        action: CoinSlotMachineActions.attack,
        message: "SlotMachine.Message.Attack",
        effect: "slotmachine.attack"
    },
    {
        payline: ["raid", "raid", "raid"],
        spine: bundles.slotmachine.jsons.reward_raid_json,
        icon_animation: "raid_reward",
        action: CoinSlotMachineActions.raid,
        message: "SlotMachine.Message.Raid",
        effect: "slotmachine.raid"
    }
];

if (cleverapps.config.debugMode) {
    CoinSlotMachine.DEBUG_PAYLINES = [
        [["stack", "attack", "stack"], ["coin", "attack", "coin"], ["coin", "attack", "shield"], ["shield", "attack", "stack"], ["stack", "stack", "stack"], ["coin", "coin", "coin"]],
        ["energy", "energy", "energy"],
        [["raid", "shield", "energy"], ["shield", "energy", "attack"], ["energy", "attack", "raid"], ["raid", "raid", "shield"]],
        ["attack", "attack", "attack"],
        ["raid", "raid", "raid"],
        ["shield", "shield", "shield"]
    ];
}

CoinSlotMachine.FIRST_SESSION_PAYLINES = [
    ["stack", "stack"],
    ["stack", "stack", "stack"],
    ["coin", "coin", "coin"],
    ["attack", "attack", "attack"],
    ["stack"],
    ["shield", "shield", "shield"],
    ["coin", "coin"],
    ["energy", "energy", "energy"],
    ["stack", "stack", "stack"],
    ["coin"],
    ["attack", "attack", "attack"],
    ["coin", "coin", "coin"],
    ["coin"],
    ["raid", "raid", "raid"],
    ["coin", "coin", "coin"],
    ["coin"],
    ["coin", "coin"],
    ["energy", "energy", "energy"]
];

CoinSlotMachine.FORCES = [
    {
        spin: 3,
        message: "Tutorial.SlotMachine.AttackForce"
    },
    {
        spin: 5,
        message: "Tutorial.SlotMachine.ShieldsForce"
    },
    {
        spin: 13,
        message: "Tutorial.SlotMachine.RaidForce"
    }
];